import {LOGIN, LOGOUT, REFRESH_TOKEN, SET_ERROR, SET_PROFILE} from '../module/types'
import {isNonEmptyString} from './utils'

export default {
  [LOGIN](state, {roles, accessToken} = {}) {
    // Both role and accessToken must be supplied.
    if (roles.length >= 0 && isNonEmptyString(accessToken)) {
      state.roles = roles
      state.accessToken = accessToken
    }
  },

  [LOGOUT](state) {
    state.roles = []
    state.accessToken = ''

    state.uid = ''
    state.name = ''
    state.email = ''
    state.picture = ''
  },

  [REFRESH_TOKEN](state, accessToken) {
    // Only LOGOUT can clear the token.
    if (isNonEmptyString(accessToken)) {
      state.accessToken = accessToken
    }
  },

  [SET_PROFILE](state, payload) {
    state.uid = payload.uid || ''
    state.name = payload.name || ''
    state.email = payload.email || ''
    state.picture = payload.picture || ''
  },

  [SET_ERROR](state, payload) {
    state.error.errorCode = payload.errorCode || ''
    state.error.message = payload.message || ''
  }
}
